import apple from '../../assets/images/logos/apple-bg.png'
import primeVideo from '../../assets/images/logos/prime-video-bg.png'
import facebook from '../../assets/images/logos/facebook-bg.png'
import hob from '../../assets/images/logos/hob-bg.png'
import discovery from '../../assets/images/logos/discovery-bg.png'
import cnn from '../../assets/images/logos/cnn-bg.png'
import netflix from '../../assets/images/logos/netflix-bg.png'
import starz from '../../assets/images/logos/starz-bg.png'

import slck from '../../assets/images/logos/slack.svg'
import mailchimp from '../../assets/images/logos/mailchimp.svg'
import dropbox from '../../assets/images/logos/dropbox.svg'
import googleDrive from '../../assets/images/logos/google-drive.svg'
import googeAdManager from '../../assets/images/logos/google-ad-manager.svg'
import atlassian from '../../assets/images/logos/atlassian.svg'

import varonicaAdams from '../../assets/images/photos/people/veronica-adams.jpg'
import varonicaAdams2 from '../../assets/images/photos/people/veronica-adams@2x.jpg'
import akachiLuccini from '../../assets/images/photos/people/akachi-luccini.jpg'
import akachiLuccini2 from '../../assets/images/photos/people/akachi-luccini@2x.jpg'
import jackSmith from '../../assets/images/photos/people/jack-smith.jpg'
import jackSmith2 from '../../assets/images/photos/people/jack-smith@2x.jpg'

export const servicesData = [
  {
    icon: 'fas fa-file-medical-alt',
    title: 'Streamline the audit process',
    subtitle:
      'Use Conduiit to perform pre-audits on transactions to identify missing qualified expenses and supporting documentation.',
  },
  {
    icon: 'fas fa-folder-open',
    title: 'Reduce file management time',
    subtitle:
      'Use Conduiit to upload and manage files, instead of assorted tools like DropBox, Box.com and Google Drive.',
  },
  {
    icon: 'fas fa-mail-bulk',
    title: 'Reduce email clutter and data entry',
    subtitle:
      'Manage files, purchase orders, payment requests and approvals in Conduiit rather than email. Export detail to MediaWeb, ProBook, Luca, Showbiz, PSL and other production accounting softwares.',
  },
  {
    icon: 'fas fa-mail-bulk',
    title: 'Train new employees faster',
    subtitle:
      'Use Conduiit to guide new production office and accounting employees instead of checklists and procedures memos.',
  },
  {
    icon: 'fas fa-exclamation-triangle',
    title: 'Identify errors in advance',
    subtitle:
      'Use Conduiit to identify miscoded submissions, missing files and unapproved submissions.',
  },
  {
    icon: 'fas fa-bell',
    title: 'Receive real time notifications',
    subtitle:
      'Use Conduiit to get instant information about KPIs and other important information.',
  },
]

export const partners = [
  {
    name: 'Apple',
    logo: apple,
  },
  {
    name: 'Prime Video',
    logo: primeVideo,
  },
  {
    name: 'Facebook Watch',
    logo: facebook,
  },
  {
    name: 'Hob',
    logo: hob,
  },
  {
    name: 'Discovery',
    logo: discovery,
  },
  {
    name: 'Cnn',
    logo: cnn,
  },
  {
    name: 'Netflix',
    logo: netflix,
  },
  {
    name: 'Starz',
    logo: starz,
  },
]

export const props = [
  'Lifetime updates',
  'Tech support',
  'Tons of assets',
  'Integration ready',
]

export const users = [
  {
    logo: slck,
    name: 'Slack',
  },
  {
    logo: mailchimp,
    name: 'Mailchimp',
  },
  {
    logo: dropbox,
    name: 'Dropbox',
  },
  {
    logo: googleDrive,
    name: 'Google Drive',
  },
  {
    logo: googeAdManager,
    name: 'Google Ad Manager',
  },
  {
    logo: atlassian,
    name: 'Atlassian',
  },
]

export const reviews = [
  {
    authorPhoto: {
      src: varonicaAdams,
      srcSet: `${varonicaAdams2} 2x`,
    },
    authorName: 'Veronica Adams',
    authorOccupation: 'Growth Marketer, Crealytics',
    feedback:
      'Lorem ipsum dolor sit amet, consectetur adipiscing elit, sed do eiusmod tempor incididunt ut labore et dolore magna aliqua.',
  },
  {
    authorPhoto: {
      src: akachiLuccini,
      srcSet: `${akachiLuccini2} 2x`,
    },
    authorName: 'Akachi Luccini',
    authorOccupation: 'Lead Generation, Alternative Capital',
    feedback:
      'Excepteur sint occaecat cupidatat non proident, sunt in culpa qui officia deserunt mollit anim id est laborum.',
  },
  {
    authorPhoto: {
      src: jackSmith,
      srcSet: `${jackSmith2} 2x`,
    },
    authorName: 'Jack Smith',
    authorOccupation: 'Head of Operations, Parkfield Commerce',
    feedback:
      'Ut enim ad minim veniam, quis nostrud exercitation ullamco laboris nisi ut aliquip ex ea commodo consequat.',
  },
  {
    authorPhoto: {
      src: varonicaAdams,
      srcSet: `${varonicaAdams2} 2x`,
    },
    authorName: 'Veronica Adams',
    authorOccupation: 'Growth Marketer, Crealytics',
    feedback:
      'Lorem ipsum dolor sit amet, consectetur adipiscing elit, sed do eiusmod tempor incididunt ut labore et dolore magna aliqua.',
  },
  {
    authorPhoto: {
      src: akachiLuccini,
      srcSet: `${akachiLuccini2} 2x`,
    },
    authorName: 'Akachi Luccini',
    authorOccupation: 'Lead Generation, Alternative Capital',
    feedback:
      'Excepteur sint occaecat cupidatat non proident, sunt in culpa qui officia deserunt mollit anim id est laborum.',
  },
  {
    authorPhoto: {
      src: jackSmith,
      srcSet: `${jackSmith2} 2x`,
    },
    authorName: 'Jack Smith',
    authorOccupation: 'Head of Operations, Parkfield Commerce',
    feedback:
      'Ut enim ad minim veniam, quis nostrud exercitation ullamco laboris nisi ut aliquip ex ea commodo consequat.',
  },
]

export const pricings = [
  {
    title: 'Standard License',
    subtitle: 'A pay-once license, just for you',
    price: 'Pending',
    priceSuffix: ' / MO',
    features: [
      'Rich, responsive landing pages',
      '100+ styled components',
      'Flexible, simple license',
      'Speedy build tooling',
      '6 months free support included',
    ],
    disclaimer: 'Fully featured 30-day free trial',
    isHighlighted: false,
  },
  {
    title: 'Extended License',
    subtitle: 'A pay-once license, just for you',
    price: '$Pending',
    priceSuffix: ' / MO',
    features: [
      'Rich, responsive landing pages',
      '100+ styled components',
      'Flexible, simple license',
      'Speedy build tooling',
      '6 months free support included',
    ],
    disclaimer: 'Fully featured 30-day free trial',
    isHighlighted: true,
  },
  {
    title: 'Enterprise License',
    subtitle: 'A pay-once license, just for you',
    price: '$Pending',
    priceSuffix: ' / MO',
    features: [
      'Rich, responsive landing pages',
      '100+ styled components',
      'Flexible, simple license',
      'Speedy build tooling',
      '6 months free support included',
    ],
    disclaimer: 'Fully featured 30-day free trial',
    isHighlighted: false,
  },
]

export const faq = [
  {
    id: 'faq-1',
    title: 'Flexible access to facilities.',
    subtitle: 'Our new key fobs make it so easy!',
    text: 'Lorem ipsum dolor sit amet, consectetur adipisicing elit. Sunt rerum minima a possimus, amet perferendis, temporibus obcaecati pariatur.',
    link: 'Check it out',
  },
  {
    id: 'faq-2',
    title: 'Snacks, drinks, coffee, and more.',
    subtitle: 'Our new key fobs make it so easy!',
    text: 'Lorem ipsum dolor sit amet, consectetur adipisicing elit. Sunt rerum minima a possimus, amet perferendis, temporibus obcaecati pariatur.',
    link: 'Check it out',
  },
  {
    id: 'faq-3',
    title: 'On site tech support.',
    subtitle: 'Our new key fobs make it so easy!',
    text: 'Lorem ipsum dolor sit amet, consectetur adipisicing elit. Sunt rerum minima a possimus, amet perferendis, temporibus obcaecati pariatur.',
    link: 'Check it out',
  },
  {
    id: 'faq-4',
    title: 'Flexible access to facilities.',
    subtitle: 'Our new key fobs make it so easy!',
    text: 'Lorem ipsum dolor sit amet, consectetur adipisicing elit. Sunt rerum minima a possimus, amet perferendis, temporibus obcaecati pariatur.',
    link: 'Check it out',
  },
  {
    id: 'faq-5',
    title: 'Snacks, drinks, coffee, and more.',
    subtitle: 'Our new key fobs make it so easy!',
    text: 'Lorem ipsum dolor sit amet, consectetur adipisicing elit. Sunt rerum minima a possimus, amet perferendis, temporibus obcaecati pariatur.',
    link: 'Check it out',
  },
  {
    id: 'faq-6',
    title: 'On site tech support.',
    subtitle: 'Our new key fobs make it so easy!',
    text: 'Lorem ipsum dolor sit amet, consectetur adipisicing elit. Sunt rerum minima a possimus, amet perferendis, temporibus obcaecati pariatur.',
    link: 'Check it out',
  },
]
